import DeploySetting from "@/pages/systemsettings/components/deploySetting.vue";
import ApiErrorList from "@/pages/systemsettings/components/apiErrorList.vue";
import DeployOther from "@/pages/systemsettings/components/DeployOther.vue";
export default {
  components: {
    ApiErrorList: ApiErrorList,
    DeploySetting: DeploySetting,
    DeployOther: DeployOther
  },
  i18n: require("./i18n-basucSettings"),
  data: function data() {
    return {
      tabKey: '1'
    };
  },
  mounted: function mounted() {},
  methods: {
    tabChange: function tabChange(activeKey) {
      //tabs 切换事件
      this.tabKey = activeKey;
    }
  }
};